import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";

import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import HairBuyingBadge from "@/components/HairBuyingBadge";
import CartDrawer from "@/components/CartDrawer";
import { CartProvider } from "@/context/CartContext";

import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import B2BInquiry from "@/pages/Contact";
import QuizPage from "@/pages/QuizPage";
import PhilosophyPage from "@/pages/PhilosophyPage";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import CheckoutCancel from "@/pages/CheckoutCancel";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CartProvider>
          <ScrollToTop />
          <Navigation />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/termekek" element={<Products />} />
            <Route path="/termek/:productId/:slug" element={<ProductDetail />} />
            <Route path="/termek/:productId" element={<ProductDetail />} />
            <Route path="/b2b" element={<B2BInquiry />} />
            <Route path="/kapcsolat" element={<B2BInquiry />} />
            <Route path="/kerdoiv" element={<QuizPage />} />
            <Route path="/filozofia" element={<PhilosophyPage />} />
            <Route path="/penztar" element={<Checkout />} />
            <Route path="/rendeles-sikeres" element={<OrderSuccess />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/checkout/cancel" element={<CheckoutCancel />} />
            <Route path="/adatvedelem" element={<PrivacyPolicy />} />
            <Route path="/cookie-tajekoztato" element={<CookiePolicy />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
          </Routes>
          <Footer />
          <HairBuyingBadge />
          <CartDrawer />
          <Toaster
            position="bottom-center"
            toastOptions={{
              className:
                "!bg-[color:var(--he-ink)] !text-[color:var(--he-bg)] !border !border-[color:var(--he-gold)]/30 !rounded-none",
              style: {
                fontFamily: "Jost, sans-serif",
                letterSpacing: "0.04em",
              },
            }}
          />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
